<template>
  <div class="cash-audit">
    <div class="pictrue"><img src="@assets/images/examine.png" /></div>
    <div class="tip">转换已成功，请联系对方核实</div>
    <div class="time">{{ time }}</div>
    <div
      class="bnt bg-color-red"
      @click="$router.push({ path: '/user/changecord' })"
    >
      好的
    </div>
  </div>
</template>
<script>
export default {
  name: "ThangeAudit",
  components: {},
  props: {},
  data: function() {
    return {
      time: ""
    };
  },
  mounted: function() {
    let myData = new Date();
    this.time = myData.toLocaleString();
  },
  methods: {}
};
</script>
